export const AdminColors = {
    green10: "#def5ea",
    green20: "#c2dfd2",
    green30: "#a9ccbd",
    green50: "#699884",
    green80: "#1f4132",
    green90: "#173629",
}